module.exports = __webpack_public_path__ + "img/emo_17.4d2933c0.gif";